import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import getFilePath from "helpers/get-file-path";
import RichText from "components/rich-text";
import Image from "components/image";
import {
  mediaTab, mediaTabButtons, mediaTabContainer, mediaTabText,
  mediaTabButtonsItem, buttonActive, mediaTabItem, mediaTabImage,
  tabActive, mediaTabVideo, mediaTabItemReverse,
  mediaTabButtonsDesktop, mediaTabButtonsMobile,
  responsiveContainer, mediaTabButtonsContainer
} from "./style.mod.scss";
import { lazyLoadVideos } from "helpers/lazyLoadVideos";
import ColoredMediaTab from "./colored-media-tabs";
import ProductsMediaTab from "./products-media-tab";
import { trackTabClick } from "helpers/analytics";

const MediaTab = ({ data }) => {
  const [tabActiveKey, setTabActive] = useState(null);
  const { tabs } = data;
  const isButtonActive = (_key, index) => (!tabActiveKey && index === 0) || (tabActiveKey === _key);

  const Button = ({ tab, index }) => (<button
    key={tab?._key}
    onClick={() => { setTabActive(tab?._key); trackTabClick(tab?.title); }}
    className={`${mediaTabButtonsItem} ${isButtonActive(tab?._key, index) ? buttonActive : ""}`}>
    {tab?.title}
  </button>);

  useEffect(() => {
    lazyLoadVideos();
  }, []);

  if (data?.coloredMediaTabs) {
    return <ColoredMediaTab data={data} />;
  } else if (data?.productsMediaTabs) {
    return <ProductsMediaTab data={data} />;
  }
  else {
    return (
      <div className={`${mediaTab} ${(data.alternate) ? mediaTabItemReverse : ""}`}
        style={{ backgroundColor: data.bgColor && data.bgColor.hex }} >
        <Container className={responsiveContainer}>
          <div className={`${mediaTabButtons} ${mediaTabButtonsDesktop}`}>
            {tabs?.map((tab, index) => <Button key={tab?._key} tab={tab} index={index} />)}
          </div>
          <div className={mediaTabContainer}>
            {
              tabs?.map((tab, index) => {
                const { video, _key, image, text, videoURL } = tab;
                const alt = image?.alt?.replace("Olav ", "Olavson ");
                return (
                  <div key={_key} className={`${mediaTabItem} ${((tabActiveKey === null && index === 0) || (tabActiveKey === _key)) && tabActive}`}>
                    <div className={mediaTabText}>
                      <RichText blocks={text} />
                    </div>
                    <div className={`${mediaTabButtonsContainer}`}>
                      <div className={`${mediaTabButtons} ${mediaTabButtonsMobile}`}>
                        {tabs?.map((tab, index) => <Button key={tab?._key} tab={tab} index={index} />)}
                      </div>
                    </div>
                    <div className={mediaTabImage}>
                      {
                        video ?
                          <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className={mediaTabVideo}
                          >
                            <source data-src={videoURL ? videoURL : getFilePath(video)} />
                          </video>
                          :
                          <Image className={mediaTabVideo} image={image} alt={alt} />
                      }
                    </div>
                  </div>
                );
              })
            }
          </div>
        </Container>
      </div>
    );
  }
};

export default MediaTab;
